// 월별 승률 스파크라인(최대 6개월 정도). 각 셀: 막대 + 승률(%) + 월 라벨.

import type { MonthlyEntry } from "../../stats";

interface MonthlySparklineProps {
  entries: Array<[string, MonthlyEntry]>;
}

export function MonthlySparkline({ entries }: MonthlySparklineProps) {
  const rates = entries.map(([, c]) => {
    const dec = c.wins + c.losses;
    return dec > 0 ? c.wins / dec : null;
  });
  return (
    <div class="sparkline">
      {entries.map(([ym], i) => {
        const r = rates[i];
        const pct = r == null ? 0 : Math.round(r * 100);
        return (
          <div class="sparkline__cell">
            <div class="sparkline__bar">
              <span
                class="sparkline__bar-fill"
                style={`height:${Math.max(4, pct)}%`}
              />
            </div>
            <span class="sparkline__val">{r == null ? "-" : `${pct}%`}</span>
            <span class="sparkline__mon">{`${Number(ym.slice(5, 7))}월`}</span>
          </div>
        );
      })}
    </div>
  );
}
